import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import CardHeader from '@material-ui/core/CardHeader';
import FormGroup from '@material-ui/core/FormGroup';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';

import Input from "../../components/UI/Input/Input";

import {
    onSubmit,
    initializeExternalSysComponent,
    onFieldChange    
} from '../../actions/ExternalSystems';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
  card: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

class AddExternalSystem extends Component {
    componentDidMount(){
        this.props.initializeExternalSysComponent();
    }
    
    render(){
        const { classes } = this.props;
        
        let { 
            externalSystemForm
        } = this.props.externalSystems;

        const formElementArray = [];

        for(let key in externalSystemForm){
            formElementArray.push({
                id : key,
                config : externalSystemForm[key]
            })
        }

        let externalSystemInputForm = (
            <FormGroup row>
                <Grid container spacing={24}>
                    {
                        formElementArray.map(formElement => {
                            return(
                                <Grid item xs={12} sm = {4} key = {formElement.id}>
                                    <Input 
                                        key = {formElement.id}
                                        name = {formElement.config.elementConfig.label}
                                        elementType={formElement.config.elementType}
                                        elementConfig={formElement.config.elementConfig}
                                        // value={formElement.config.value} //TODO: Review - Clearing the value entered in this class not others though.
                                        menuItems = {formElement.config.menuItems}
                                        error = {formElement.config.errorStatus}
                                        helperText = {formElement.config.errorMessage}
                                        changed={(event) => this.props.onFieldChange(formElement.id, event)}
                                        maxLength = {formElement.config.maxLength}
                                        disabledStatus = {formElement.config.disabledStatus}
                                    />
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </FormGroup>
        )
        
        return(
            <div className = "container">
                <Card 
                    // className={classes.card} 
                    className = "pl-3 pr-3 pt-3 mb-5"
                >
                <CardHeader
                    title="ADD EXTERNAL SYSTEM"
                />
                    <CardContent>
                    {
                        <div>
                            {externalSystemInputForm}
                            <Grid 
                                container 
                                spacing={24} 
                                className = "pt-2"
                                direction="row" 
                                justify="flex-end"
                                alignItems="center"
                            >
                                <Grid item>
                                {
                                    <div>
                                        <Button
                                            variant="contained" 
                                            color="primary" 
                                            className = "mr-3"
                                            disabled={false}
                                            onClick = {() => {this.props.onSubmit(externalSystemForm, this.props)}}
                                        >
                                            Add
                                        </Button>
                                    </div>
                                }
                                </Grid> 
                            </Grid>
                        </div>
                    }
                    </CardContent>
                </Card>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return{
        externalSystems: state.externalSystems
    };
};

const mapDispatchToProps = dispatch => {
    return{
        initializeExternalSysComponent : () => {
            return dispatch(initializeExternalSysComponent())
        },

        onSubmit: (externalSystemForm, props) => {
            return dispatch(onSubmit(externalSystemForm, props))
        },

        
        onFieldChange : (formElementId, event) => {
            return dispatch(onFieldChange(formElementId, event))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps) (AddExternalSystem);